import * as policyEvents from "./policyEventsConstants";
import {ROLES} from "./roleConstants";

type PolicyFn = (roles: (number | undefined)[], patronRole: number | undefined, patronSubType: number | undefined) => boolean;

export class DefaultPolicy {
    private _policy: Record<string, PolicyFn>;
    private _roles: (number | undefined)[];
    private _patronRole: number | undefined;
    private _patronSubType: number | undefined;

    constructor(roles: (number | undefined)[], patronRole: number | undefined, patronSubType: number | undefined) {
        this._policy = {};
        this._roles = roles;
        this._patronRole = patronRole;
        this._patronSubType = patronSubType;

        this.initializePolicy();
    }

    permit(policyEvent: string): boolean {
        if (!policyEvent)
            return false;

        if (this._policy[policyEvent])
            return this._policy[policyEvent](this._roles, this._patronRole, this._patronSubType);

        return false;
    }

    initializePolicy(): void {
        this._policy[policyEvents.VIEW] = function (roles) {
            return roles.some((role: number | undefined) => role !== ROLES.Patron);
        };
        this._policy[policyEvents.ADVANCE_SEARCH] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.APPROVE_USERS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.DELETE] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_CATALOG] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.VIEW_LOAN_LIBRARY] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_LOAN_LIBRARY_CATALOG] = this._policy[policyEvents.MANAGE_LOAN_LIBRARY_LOANS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_OWN_LOANS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_OWN_CATALOG_ITEMS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_OWN_LOANS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
        this._policy[policyEvents.MANAGE_OWN_CATALOG_ITEMS] = function (roles) {
            return roles.includes(ROLES.RmtcAdmin);
        };
    }
}
